module.exports = "\n\n\n<div>Stripe checkout completed!</div>"